module.exports = __webpack_public_path__ + "static/tag-financial-planning-logo-white-21a3343566afd1474c1ea882ceb15d2b.svg";